import RecoverMessage from './RecoverMessage';

export default RecoverMessage;